export default __webpack_public_path__ + "static/media/labtestnew.fe317f2b.svg";